import _has from 'lodash/has';
import _get from 'lodash/get';
import _isUndefined from 'lodash/isUndefined';

function verifyAndGetData(result, config) {
    const { ret, data } = result
    if (ret !== 0) throw { config, result }

    return data
}

function verifyAndGetValue(data, path, defaultValue) {
    if (!_has(data, path) && _isUndefined(defaultValue)) throw 'incorrect data structure.'

    return _get(data, path, defaultValue)
}

function verifyAndGetToken(token) {
    if (!token) throw 'incorrect token.'

    return token
}

export { verifyAndGetData, verifyAndGetValue, verifyAndGetToken }
